import { render, staticRenderFns } from "./pedidos_formas-pago.vue?vue&type=template&id=157e19b3&"
import script from "./pedidos_formas-pago.vue?vue&type=script&lang=js&"
export * from "./pedidos_formas-pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports